import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/firestore'

const firebaseConfig = {
  apiKey: 'AIzaSyDrufQAG4jFDp4uU72tgVAfEWYAdkpD7qA',
  authDomain: 'trartist-com.firebaseapp.com',
  databaseURL: 'https://trartist-com.firebaseio.com',
  projectId: 'trartist-com',
  storageBucket: 'trartist-com.appspot.com',
  messagingSenderId: '155419655464',
  appId: '1:155419655464:web:26e3fd759177cdde'
}

export default firebase.initializeApp(firebaseConfig)
